// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { BASE_URL } from '../apiConfig';
// import SallerBank from "../cors/SallerBank";
// import { useAuth } from "../context/AuthProvider";
// import { toast } from 'sonner';
// import DeleteModal from '../cors/DeleteModal'; 
// import { useLanguage } from "../context/LanguageProvider";

// export default function SellerCard({ seller , fetchSellers ,Page, searchTerm }) {
//   const { token, role, roles } = useAuth();
//   const { t } = useLanguage();
//   const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
//   const [isModalOpen, setIsModalOpen] = useState(false);
  

//   const handleStatusToggle = async () => {
//     setIsUpdatingStatus(true);
//     const obj = {
//       "user_id": seller.id,
//       "status": !seller.status
//     };
    
//     try {
//       const response = await fetch(`${BASE_URL}/api/updatesellerstatus`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`
//         },
//         body: JSON.stringify(obj)
//       });

//       const data = await response.json();

//       if (!response.ok || data.code !== 200) {
//         throw new Error(data.message || t('sellers.status_update_failed'));
//       }

//       fetchSellers(Page, searchTerm);
      
//       toast.success(data.message || t('sellers.status_updated'));
      
//     } catch (error) {
//       console.error('Error updating status:', error);
//       toast.error(error.message || t('sellers.status_update_error'));
//     } finally {
//       setIsUpdatingStatus(false);
//     }
//   };

//   const deleteSaller = async () => {
//     setIsModalOpen(false); 

//     try {
//       const res = await fetch(BASE_URL+`/api/users/${seller.id}`, {
//         method: "DELETE",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       })

//       if (res.ok) {
//         toast.success(t('sellers.delete_success'));
//         fetchSellers(Page, searchTerm);
//       } else {
//         const err = await res.json()
//         toast.error(t('sellers.delete_failed'));
//       }
//     } catch (error) {
//       toast.error(t('sellers.delete_failed'));
//     }
//   }

//   const formatDate = (dateString) => {
//     if (!dateString || dateString === "") return t('sellers.never');
//     return new Date(dateString).toLocaleDateString("fr-FR", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const formatPhone = (phone) => {
//     if (!phone) return t('sellers.not_provided');
//     const phoneStr = phone.toString();
//     return phoneStr.replace(/(\d{2})(\d{3})(\d{4})/, "($1) $2-$3");
//   };

//   const getActivityStatus = () => {
//     if (!seller.info.last_login_at || seller.info.last_login_at === "") {
//       return { 
//         status: t('sellers.never_connected'),
//         color: "text-red-600 bg-red-100",
//         bg: "bg-red-600",
//         tooltip: t('sellers.never_connected_tooltip')
//       };
//     }
    
//     const lastLogin = new Date(seller.info.last_login_at);
//     const now = new Date();
//     const diffInSeconds = Math.floor((now - lastLogin) / 1000);
//     const minutesPassed = Math.floor(diffInSeconds / 60);
//     const hoursPassed = Math.floor(minutesPassed / 60);
//     const daysPassed = Math.floor(hoursPassed / 24);

//     if (diffInSeconds < 60) {
//       return {
//         status: t('sellers.online'),
//         color: "text-green-600 bg-green-100",
//         bg: "bg-green-600",
//         tooltip: `${t('sellers.online_now')} (${lastLogin.toLocaleString()})`
//       };
//     }
//     if (minutesPassed < 60) {
//       return {
//         status: `En ligne (${minutesPassed} min)`,
//         color: "text-green-600 bg-green-100",
//         bg: "bg-green-600",
//         tooltip: `Actif il y a ${minutesPassed} minutes`
//       };
//     }
//     if (hoursPassed < 24) {
//       return {
//         status: `En ligne (${hoursPassed}h)`,
//         color: "text-blue-600 bg-blue-100",
//         bg: "bg-blue-600",
//         tooltip: `Actif il y a ${hoursPassed} heures`
//       };
//     }
//     if (daysPassed === 1) {
//       return {
//         status: t('sellers.online_one_day'),
//         color: "text-yellow-600 bg-yellow-100",
//         bg: "bg-yellow-600",
//         tooltip: `Actif hier (${lastLogin.toLocaleString()})`
//       };
//     }
//     if (daysPassed < 7) {
//       return {
//         status: `En ligne (${daysPassed}j)`,
//         color: "text-amber-600 bg-amber-100",
//         bg: "bg-amber-600",
//         tooltip: `Actif il y a ${daysPassed} jours`
//       };
//     }
//     if (daysPassed < 30) {
//       const weeksPassed = Math.floor(daysPassed / 7);
//       return {
//         status: weeksPassed === 1 ? "En ligne (1 sem.)" : `En ligne (${weeksPassed} sem.)`,
//         color: "text-orange-600 bg-orange-100",
//         bg: "bg-orange-600",
//         tooltip: `Actif il y a ${weeksPassed} semaine${weeksPassed > 1 ? 's' : ''}`
//       };
//     }
//     return {
//       status: t('sellers.inactive'),
//       color: "text-red-600 bg-red-100",
//       bg: "bg-red-600",
//       tooltip: `Dernière activité il y a plus d'un mois (${lastLogin.toLocaleDateString()})`
//     };
//   };

//   const activity = getActivityStatus();
//   const sellerRating = seller.info.level === "Beginner" ? 1 : seller.info.level === "Intermediate" ? 2 : 3;

//   return (
//     <div className="relative group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:-translate-y-2">
//       {/* En-tête */}
//       <div className="px-4 pb-2 pt-4 bg-white">
//         <div className="flex items-center justify-between mb-2">
//           <div>
//             {seller.info.logo ?
//               <img 
//                 src={`${BASE_URL}/storage/${seller.info.logo}`}
//                 width={50}
//                 height={50}
//                 className="h-12 object-cover rounded-2xl"
//                 alt="logo" />
//               :
//               <div className="w-12 h-12 bg-[var(--color-primary-50)] rounded-2xl flex items-center justify-center">
//                 <svg className="h-6 w-6 text-[var(--color-primary-500)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                   />
//                 </svg>
//               </div>
//             }
//           </div>
//           <div className="flex flex-col items-end">
//             <span className={`flex items-center gap-0.5 px-1.5 py-0.5 rounded-full font-semibold text-[9px] ${activity.color} mb-1`}>
//               <span className={`${activity.bg} h-1.5 w-1.5 rounded-full`}></span>
//               {activity.status}
//             </span>
//             <span className="px-1 flex rounded-full text-xs font-semibold text-purple-600">
//               {[1, 2, 3].map((star) => (
//                 <svg
//                   key={star}
//                   className={`h-3.5 w-3.5 ${
//                     star <= sellerRating ? "text-yellow-400" : "text-gray-300"
//                   }`}
//                   fill="currentColor"
//                   viewBox="0 0 20 20"
//                 >
//                   <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.683-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.565-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                 </svg>
//               ))}
//             </span>
//           </div>
//         </div>

//         <h3 className="text-xs  text-gray-600 group-hover:text-[var(--color-primary-500)] transition-colors duration-300">
//           {seller.info.name || seller.email}
//         </h3>
//         <p className="text-gray-900 font-bold text-lg">{seller.info.name_store}</p>
//       </div>

//       <div className="px-4 pb-2">
//         <div className="space-y-3 mb-2">
//           <div className="grid grid-cols-2 gap-1">
//             <div className="space-y-2">
//               <div className="flex items-center text-xs text-gray-600">
//                 <svg className="h-3.5 w-3.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                   />
//                 </svg>
//                 {formatPhone(seller.info.phone)}
//               </div>
          
//               <div className="flex items-center text-[11px] text-gray-600">
//                 <SallerBank bank={seller.info.name_bank} />  
//               </div>
//             </div>
//             <div>
//               {
//                 (role === 1 || (role === 2 && roles.update_saller_status === 1)) &&
//                   <div className="flex items-end justify-end gap-1">
//                     <button
//                           onClick={handleStatusToggle}
//                           disabled={isUpdatingStatus}
//                           className={`rounded-full text-[10px] pr-0.3 pl-[4px] ml-3 font-medium transition-all duration-200 flex items-center space-x-1 ${
//                             seller.status
//                               ? "bg-green-500 hover:bg-green-600 text-white"
//                               : "bg-red-500 hover:bg-red-600 text-white"
//                           } ${isUpdatingStatus ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
//                         >
//                           {isUpdatingStatus ? (
//                             <>
//                               <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
//                                 <circle
//                                   className="opacity-25"
//                                   cx="12"
//                                   cy="12"
//                                   r="10"
//                                   stroke="currentColor"
//                                   strokeWidth="4"
//                                 ></circle>
//                                 <path
//                                   className="opacity-75"
//                                   fill="currentColor"
//                                   d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                 ></path>
//                               </svg>
//                               <span>{t('sellers.updating')}</span>
//                             </>
//                           ) : (
//                             <>
//                               <div className={`w-1.5 h-1.5 rounded-full ${seller.status ? "bg-white" : "bg-white"}`}></div>
//                               <span>{seller.status ? t('sellers.active') : t('sellers.disabled')}</span>
//                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M8 9l4-4 4 4m0 6l-4 4-4-4"
//                                 />
//                               </svg>
//                             </>
//                           )}
//                         </button>
//                   </div>
//               }
//             </div>
//           </div>
          
//           {seller.total_sales && (
//             <div className="flex items-center text-xs text-gray-600">
//               <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               {t('sellers.total_sales')} : {seller.total_sales} {t('categories.items')}
//             </div>
//           )}
//         </div>

//         {/* Boutons d'action */}
//         <div className="flex justify-between items-center gap-2">
//           <div className="flex items-center text-[9px] text-gray-600">
//             <svg className="h-3.5 w-3.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
//               />
//             </svg>
//             {t('sellers.registered_on')} : {formatDate(seller.info.created_at)}
//           </div>
//           <div className="flex gap-2">
//             {
//               (role === 1 || (role === 2 && roles.edit_saller === 1)) &&
//                 <Link to={`/sallers/${seller.id}`}>
//                   <button 
//                     className="p-1.5 border-2 border-gray-200 cursor-pointer hover:border-[var(--color-primary-500)] text-gray-600 hover:text-[var(--color-primary-500)] rounded-xl transition-all duration-300"
//                     title={t('sellers.edit_seller')}
//                   >
//                     <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                       />
//                     </svg>
//                   </button>
//                 </Link>
//             }
//             {
//               (role === 1 || (role === 2 && roles.delete_saller === 1)) &&
//                 <button 
//                   onClick={() => setIsModalOpen(true)} 
//                   className="p-1.5 border-2 border-gray-200 cursor-pointer hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
//                   title={t('sellers.view_details')}
//                 >
//                   <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2
//                     2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
//                     1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
//                   />
//                 </svg>
//                 </button>
//             }
//           </div>
//         </div>
//       </div>
//       {
//         isModalOpen &&
//           <DeleteModal
//               isOpen={isModalOpen}
//               onClose={() => setIsModalOpen(false)}
//               onConfirm={deleteSaller}
//               title={t('sellers.delete_title')}
//               message={t('sellers.delete_message')}
//               itemName={seller.info.name}
//             />
//       }
//     </div>
//   );
// }


import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from '../apiConfig';
import SallerBank from "../cors/SallerBank";
import { useAuth } from "../context/AuthProvider";
import { toast } from 'sonner';
import DeleteModal from '../cors/DeleteModal';
import { useLanguage } from "../context/LanguageProvider";

export default function SellerCard({ seller, fetchSellers, Page, searchTerm }) {
  const { token, role, roles } = useAuth();
  const { t } = useLanguage();
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleStatusToggle = async () => {
    setIsUpdatingStatus(true);
    const obj = {
      "user_id": seller.id,
      "status": !seller.status
    };

    try {
      const response = await fetch(`${BASE_URL}/api/updatesellerstatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(obj)
      });

      const data = await response.json();

      if (!response.ok || data.code !== 200) {
        throw new Error(data.message || t('sellers.status_update_failed'));
      }

      fetchSellers(Page, searchTerm);
      toast.success(data.message || t('sellers.status_updated'));

    } catch (error) {
      console.error('Error updating status:', error);
      toast.error(error.message || t('sellers.status_update_error'));
    } finally {
      setIsUpdatingStatus(false);
      setShowMenu(false);
    }
  };

  const deleteSaller = async () => {
    setIsModalOpen(false);

    try {
      const res = await fetch(BASE_URL + `/api/users/${seller.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (res.ok) {
        toast.success(t('sellers.delete_success'));
        fetchSellers(Page, searchTerm);
      } else {
        toast.error(t('sellers.delete_failed'));
      }
    } catch (error) {
      toast.error(t('sellers.delete_failed'));
    }
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "") return t('sellers.never');
    return new Date(dateString).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatPhone = (phone) => {
    if (!phone) return t('sellers.not_provided');
    const phoneStr = phone.toString();
    return phoneStr.replace(/(\d{2})(\d{3})(\d{4})/, "($1) $2-$3");
  };

  const getActivityStatus = () => {
    if (!seller.info.last_login_at || seller.info.last_login_at === "") {
      return {
        label: t('sellers.never_connected'),
        badge: "text-red-600 bg-red-50",
        dot: "bg-red-500",
        bar: "bg-red-400",
        tooltip: t('sellers.never_connected_tooltip')
      };
    }

    const lastLogin = new Date(seller.info.last_login_at);
    const now = new Date();
    const diffInSeconds = Math.floor((now - lastLogin) / 1000);
    const minutesPassed = Math.floor(diffInSeconds / 60);
    const hoursPassed = Math.floor(minutesPassed / 60);
    const daysPassed = Math.floor(hoursPassed / 24);

    if (minutesPassed < 60) {
      return {
        label: `${t('sellers.online')} (${Math.max(minutesPassed, 1)} min)`,
        badge: "text-green-600 bg-green-50",
        dot: "bg-green-500",
        bar: "bg-green-500",
        tooltip: `Actif il y a ${minutesPassed} minutes`
      };
    }
    if (hoursPassed < 24) {
      return {
        label: `${t('sellers.online')} (${hoursPassed}h)`,
        badge: "text-green-600 bg-green-50",
        dot: "bg-green-500",
        bar: "bg-green-500",
        tooltip: `Actif il y a ${hoursPassed} heures`
      };
    }
    if (daysPassed < 7) {
      return {
        label: `${t('sellers.online')} (${daysPassed}j)`,
        badge: "text-amber-600 bg-amber-50",
        dot: "bg-amber-500",
        bar: "bg-amber-400",
        tooltip: `Actif il y a ${daysPassed} jours`
      };
    }
    return {
      label: t('sellers.inactive'),
      badge: "text-red-600 bg-red-50",
      dot: "bg-red-500",
      bar: "bg-red-400",
      tooltip: `Dernière activité le ${lastLogin.toLocaleDateString()}`
    };
  };

  const activity = getActivityStatus();
  const sellerRating = seller.info.level === "Beginner" ? 1 : seller.info.level === "Intermediate" ? 2 : 3;

  const canEdit = role === 1 || (role === 2 && roles.edit_saller === 1);
  const canDelete = role === 1 || (role === 2 && roles.delete_saller === 1);
  const canToggleStatus = role === 1 || (role === 2 && roles.update_saller_status === 1);

  return (
    <div className="relative group bg-white rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
      {/* Bande de statut */}
      <div className={`h-1.5 w-full ${seller.status ? "bg-green-500" : "bg-red-500"}`} />

      <div className="py-5 px-3">
        {/* En-tête : logo + badge en ligne */}
        <div className="flex items-start justify-between mb-3">
          {seller.info.logo ? (
            <img
              src={`${BASE_URL}/storage/${seller.info.logo}`}
              className="w-14 h-14 rounded-2xl object-cover border border-gray-100"
              alt="logo"
            />
          ) : (
            <div className="w-14 h-14 bg-[var(--color-primary-50)] rounded-2xl flex items-center justify-center">
              <svg className="h-7 w-7 text-[var(--color-primary-500)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          )}

          <span
            title={activity.tooltip}
            className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-semibold ${activity.badge}`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${activity.dot}`}></span>
            {activity.label}
          </span>
        </div>

        {/* Nom + note */}
        <div className="flex items-start justify-between gap-2 mb-1">
          <div className="min-w-0">
            {/* <p className="text-xs text-gray-500 truncate">
              {seller.info.name_bank || "—"} • {seller.info.city || "—"}
            </p> */}
            <h3 className="text-base font-bold text-gray-900 truncate">
              {seller.info.name_store || seller.info.name || seller.email}
            </h3>
          </div>
          <div className="flex items-center gap-0.5 shrink-0 pt-0.5">
            {[1, 2, 3].map((star) => (
              <svg
                key={star}
                className={`h-3.5 w-3.5 ${star <= sellerRating ? "text-amber-400" : "text-gray-200"}`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.683-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.565-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
        </div>

        {/* Contact + ancienneté */}
        <div className="space-y-1.5 mt-3 mb-4">
          <div className="flex items-center text-xs text-gray-500">
            <svg className="h-3.5 w-3.5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            {formatPhone(seller.info.phone)}
          </div>
          <div className="flex items-center text-xs text-gray-500">
            <svg className="h-3.5 w-3.5 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            {t('sellers.registered_on')} : {formatDate(seller.info.created_at)}
          </div>
          {seller.info.name_bank && (
            <div className="flex items-center text-xs text-gray-500">
              <SallerBank bank={seller.info.name_bank} />
            </div>
          )}
        </div>

        {/* Stats : commandes / CA / produits */}
        <div className="grid grid-cols-3 gap-1 py-3 border-t border-gray-100 mb-4 text-center">
          <div>
            <p className="text-[10px] font-medium text-gray-400">{t('sellers.orders') || 'Commandes'}</p>
            <p className="text-sm font-bold text-gray-900">{seller.total_orders ?? 0}</p>
          </div>
          <div className="border-x border-gray-100">
            <p className="text-[10px] font-medium text-gray-400">{t('sellers.revenue') || 'CA total'}</p>
            <p className="text-sm font-bold text-gray-900">{seller.total_revenue ?? 0} DH</p>
          </div>
          <div>
            <p className="text-[10px] font-medium text-gray-400">{t('sellers.products') || 'Produits'}</p>
            <p className="text-sm font-bold text-gray-900">{seller.total_products ?? 0}</p>
          </div>
        </div>

        {/* Actions */}
        {/* <div className="flex items-center gap-2">
          <Link to={`/sallers/${seller.id}`} className="flex-1">
            <button className="w-full flex items-center justify-center gap-1.5 py-2 border-2 border-gray-200 rounded-xl text-xs font-medium text-gray-600 hover:border-[var(--color-primary-500)] hover:text-[var(--color-primary-500)] transition-colors cursor-pointer">
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              {t('common.view') || 'Voir'}
            </button>
          </Link>

          {canEdit && (
            <Link to={`/sallers/edit/${seller.id}`} className="flex-1">
              <button className="w-full flex items-center justify-center gap-1.5 py-2 border-2 border-gray-200 rounded-xl text-xs font-medium text-gray-600 hover:border-[var(--color-primary-500)] hover:text-[var(--color-primary-500)] transition-colors cursor-pointer">
                <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                {t('sellers.edit_seller') || 'Éditer'}
              </button>
            </Link>
          )}
          <div>
            {
            (role === 1 || (role === 2 && roles.update_saller_status === 1)) &&
              <div className="flex items-end justify-end gap-1">
                <button
                      onClick={handleStatusToggle}
                      disabled={isUpdatingStatus}
                      className={`rounded-full text-[10px] pr-0.3 pl-[4px] ml-3 font-medium transition-all duration-200 flex items-center space-x-1 ${
                        seller.status
                          ? "bg-green-500 hover:bg-green-600 text-white"
                          : "bg-red-500 hover:bg-red-600 text-white"
                      } ${isUpdatingStatus ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                    >
                      {isUpdatingStatus ? (
                        <>
                          <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          <span>{t('sellers.updating')}</span>
                        </>
                      ) : (
                        <>
                          <div className={`w-1.5 h-1.5 rounded-full ${seller.status ? "bg-white" : "bg-white"}`}></div>
                          <span>{seller.status ? t('sellers.active') : t('sellers.disabled')}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                            />
                          </svg>
                        </>
                      )}
                    </button>
              </div>
            }
            <div>
              {
                (role === 1 || (role === 2 && roles.delete_saller === 1)) &&
                  <button 
                    onClick={() => setIsModalOpen(true)} 
                    className="p-1.5 border-2 border-gray-200 cursor-pointer hover:border-red-400 text-gray-600 hover:text-red-500 rounded-xl transition-all duration-300"
                    title={t('sellers.view_details')}
                  >
                    <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2
                      2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1
                      1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                    />
                  </svg>
                  </button>

                }
              </div>
            </div>

        </div> */}

        <div className="flex items-center gap-1">
          {/* View Button - Primary Action */}
          <Link to={`/sallers/${seller.id}`} className="flex-1">
            <button className="w-full flex items-center justify-center gap-1 px-2 py-1.5 text-gray-500 hover:text-gray-600 rounded-xl text-xs font-medium transition-all duration-200 border border-gray-300 hover:shadow-md cursor-pointer group">
              <svg className="h-3.5 w-3.5 transition-transform group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              {t('common.view') || 'Voir'}
            </button>
          </Link>

          {/* Edit Button - Secondary Action */}
          {canEdit && (
            <Link to={`/sallers/${seller.id}`} className="flex-1">
              <button className="w-full flex items-center justify-center gap-1 px-2 py-1.5 border border-gray-300 text-gray-500 hover:text-gray-600 rounded-xl text-xs font-medium transition-all duration-200 cursor-pointer group">
                <svg className="h-3.5 w-3.5 transition-transform group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                {t('sellers.edit_seller') || 'Éditer'}
              </button>
            </Link>
          )}

          {/* Action Buttons Group */}
          <div className="flex items-center gap-1.5">
            {/* Status Toggle Button */}
            {(role === 1 || (role === 2 && roles.update_saller_status === 1)) && (
              <button
                onClick={handleStatusToggle}
                disabled={isUpdatingStatus}
                className={`relative px-2 py-1.5 rounded-xl text-xs font-medium transition-all duration-200 flex items-center gap-1 ${
                  seller.status
                    ? "bg-green-500 hover:bg-green-600 text-white shadow-sm hover:shadow"
                    : "bg-red-500 hover:bg-red-600 text-white shadow-sm hover:shadow"
                } ${isUpdatingStatus ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
              >
                {isUpdatingStatus ? (
                    <>
                      <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <span className="text-[10px]">{t('sellers.updating')}</span>
                    </>
                  ) : (
                    <>
                      <div className={`w-1.5 h-1.5 rounded-full ${seller.status ? "bg-white" : "bg-white"}`}></div>
                      <span>{seller.status ? t('sellers.active') : t('sellers.disabled')}</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                        />
                      </svg>
                    </>
                  )}
              </button>
            )}

            {/* Delete Button */}
            {(role === 1 || (role === 2 && roles.delete_saller === 1)) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="p-2 border border-gray-300 hover:border-red-400 hover:bg-red-50 text-gray-500 hover:text-red-500 rounded-xl transition-all duration-200 cursor-pointer group"
                title={t('sellers.view_details')}
              >
                <svg className="h-3.5 w-3.5 transition-transform group-hover:scale-110 group-hover:rotate-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m5 0H6"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <DeleteModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={deleteSaller}
          title={t('sellers.delete_title')}
          message={t('sellers.delete_message')}
          itemName={seller.info.name}
        />
      )}
    </div>
  );
}